const DEFAULT_VARIANT = 'A';
const NOOP = () => null;

type WindowWithGA = Window & typeof globalThis & { gtag: Function };

/**
 *
 * @param {String} experimentName - the Experiment Id from Google Optimize
 * @param {Function} setVariantEnrollment - callback function invoked with variant
 */
export const enrollInOptimizeExperiment = ({
    experimentName,
    setVariantEnrollment = NOOP,
    defaultVariant = DEFAULT_VARIANT,
}: {
    experimentName: string;
    setVariantEnrollment: (variant: string) => any;
    defaultVariant?: string;
}) => {
    const windowWithGA = window as WindowWithGA;

    if (windowWithGA.gtag) {
        let variant = defaultVariant;

        windowWithGA.gtag('event', 'optimize.callback', {
            name: experimentName,
            callback: (value: string, name: string) => {
                // NB: Can add logic for specific experiements
                if (name === experimentName) {
                    if (value == '0') {
                        variant = 'A';
                    } else if (value == '1') {
                        variant = 'B';
                    } else if (value == '2') {
                        variant = 'C';
                    } else if (value == '3') {
                        variant = 'D';
                    }

                    setVariantEnrollment(variant);
                } else {
                    // just to be extra safe
                    setVariantEnrollment(defaultVariant);
                }

                return variant;
            },
        });

        // When the experiment isn't on yet then the callback never gets called.
        // The timeout is leveraged in cases where we want to prevent render of
        // any variant until the callack is triggered.
        // eg. Prevent a flicker of the default "A" experience when
        // the user is goint to be enrolled in "B"
        setTimeout(() => {
            if (variant === defaultVariant) {
                setVariantEnrollment(defaultVariant);
            }
        }, 1000);
    } else {
        // If no Optimize is available we still want to set to A for the default
        // experience if/when gtag loads it will be tracked.
        setVariantEnrollment(defaultVariant);
    }
};

// NB: Developer shortcut to force a variation
export const forceExperimentVariation = (variant = 'b') => {
    if (typeof window === 'object' && window.location) {
        const lowerCaseVariant = variant.toLowerCase();

        return window.location.href.endsWith(`#${lowerCaseVariant}`);
    }

    return false;
};
